










































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import Api from "@/api";
import Table from "@/components/Common/Table.vue";
import AlertBox from "@/components/Common/Alerts/AlertBox.vue";
import NavigationTabs from "@/components/Settings/Events/NavigationTabs.vue";

import swal from "sweetalert";
import {
  EventTimeframe,
  EventType,
  IEvent,
  IPagination,
  ITableParams
} from "@/interface";
import { AxiosResponse } from "axios";
import BaseMixin from "@/mixins/BaseMixin";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    Table,
    AlertBox,
    NavigationTabs
  }
})
export default class Events extends Mixins(BaseMixin) {
  public loading = false;
  public updating = false;
  private componentKey = 0;
  private events: Array<IEvent> = [];
  private eventTypes: Array<EventType> = [];
  private eventTimeframes: Array<EventTimeframe> = [];
  private failedRequest = false;
  private metaData: ITableParams | null = null;
  private fetchParams: IPagination = {
    page: 1,
    per_page: null,
    to: 1,
    search: ""
  };
  private timeframeFilter = "all";
  private typeFilter = "course";
  private selectedEventId: string | null = null;

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.selectedEventId = vm.$route.params.event_id;
      if (vm.$route.query.event_deleted === "true") {
        swal("Success!", "The event was deleted.", "success").then(() => {
          window.history.pushState(
            {},
            document.title,
            window.location.pathname
          );
        });
      }
      vm.getEvents(() => {
        //
      });
      vm.getEventTypes();
      vm.getEventTimeframes();
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    if (to.query.event_deleted === true) {
      swal("Success!", "The event was deleted.", "success").then(() => {
        window.history.pushState({}, document.title, window.location.pathname);
      });
    }
    this.forceRerender();
    if (
      this.fetchParams.per_page !== null &&
      this.fetchParams.per_page !== undefined &&
      this.fetchParams.to !== null &&
      this.fetchParams.to !== undefined &&
      this.fetchParams.page !== undefined &&
      this.fetchParams.to % this.fetchParams.per_page === 0 &&
      this.fetchParams.page !== 1
    ) {
      this.fetchParams.page -= 1;
    }
    this.getEvents(() => {
      //
    });
    this.getEventTypes();
    this.getEventTimeframes();
    next();
  }

  private getEvents(successCallback?: any): void {
    this.loading = true;
    this.events = [];
    const endpoint = this.$partnerEndpoint("events");

    Api()
      .get(endpoint, {
        params: {
          page: this.fetchParams.page,
          search: this.fetchParams.search,
          timeframe: this.timeframeFilter,
          type: this.typeFilter
        }
      })
      .then((response: AxiosResponse) => {
        this.events = response.data.data;
        this.metaData = response.data.meta;
        this.failedRequest = false;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch(() => {
        this.failedRequest = true;
      });
  }

  private getEventTypes(): void {
    const endpoint: string = this.$partnerEndpoint("events/types");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.eventTypes = response.data.data;
      });
  }

  private getEventTimeframes(): void {
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint("events/timeframes");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.eventTimeframes = response.data.data;
        if (this.eventTimeframes.length > 0) {
          this.timeframeFilter = this.eventTimeframes[0];
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private deleteEvent(eventId: number): void {
    if (this.loading || this.updating || eventId == null) {
      return;
    }

    swal({
      title: "Are you sure?",
      text: "The event will be deleted.",
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          visible: true,
          text: "Cancel",
          closeModal: true
        },
        confirm: {
          visible: true,
          text: "Yes, delete it!",
          closeModal: true
        }
      }
    }).then(isConfirm => {
      if (isConfirm) {
        const endpoint: string = this.$partnerEndpoint(
          "events/" + this.selectedEventId
        );

        Api()
          .delete(endpoint)
          .then(() => {
            this.$router
              .push({
                name: "Events",
                query: { event_deleted: "true" }
              })
              .catch((error: any) => {
                console.log(error);
                if (
                  error.name === "NavigationDuplicated" ||
                  error.message.includes(
                    "Avoided redundant navigation to current location"
                  )
                ) {
                  swal("Success!", "The event was deleted.", "success");
                  this.getEvents(() => {
                    //
                  });
                }
              });
          })
          .catch((error: any) => {
            if (error.response.status === 403) {
              swal({
                title: "Missing permission",
                text: "You are not allowed to delete events.",
                icon: "error"
                //dangerMode: true,
              });
            }
          });
      } else {
        //
      }
    });
  }

  private forceRerender(): void {
    this.componentKey += 1;
  }

  @Watch("typeFilter")
  typeFilterChanged(): void {
    this.getEvents(() => {
      //
    });
  }

  @Watch("timeframeFilter")
  timeframeFilterChanged(): void {
    this.getEvents(() => {
      //
    });
  }
}
